define([], function() {
    'use strict';

    var hasConsole = !!console;

    return {
        debug: hasConsole ? debug : function() {},
        info: hasConsole ? info : function() {},
        error: hasConsole ? error : function() {}
    };

    function debug() {
        console.debug.apply(console, arguments);
    }

    function info() {
        console.info.apply(console, arguments);
    }

    function warn() {
        console.warn.apply(console, arguments);
    }

    function error() {
        console.error.apply(console, arguments);
    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/util/log.js
 ** module id = 102
 ** module chunks = 0
 **/